var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header'),(this.$route.path == '/' || this.$route.path == '/regist_edit')?_c('main',{staticClass:"top"},[_c('router-view')],1):_c('main',{staticClass:"no-top"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }